module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<input id="email" type="text" placeholder="me@example.com" class="fs-hide" value="' +
__e( email ) +
'" />\n<input id="phone" type="tel" placeholder="617-505-5555" class="fs-hide"\n       pattern="[0-9]*" inputmode="numeric" value="' +
__e( phone ) +
'" />\n<input id="password" type="password" placeholder="Choose a password" />\n<span class="help-block hidden"></span>\n<small id="help-chars">Must be at least 8 characters</small>\n<small id="help-alpha">Must include both letters and numbers</small>\n';

}
return __p
}